import React from 'react';
import { observer } from 'mobx-react';
import { useRouter } from 'next/compat/router';

import { Content } from './content';
import { ConsumerUser } from '../account.types';

type ContentControllerProps = {
  user: ConsumerUser;
};

export const ContentController = observer(
  ({ user }: ContentControllerProps): JSX.Element => {
    const { query: { accountTab } = { accountTab: undefined } } = useRouter() ?? { query: {} };

    return <Content user={user} accountTab={accountTab} />;
  }
);
